import React, { useState } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import { Input } from './Input';

interface AdminActionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (data?: string) => void;
  title: string;
  message: string;
  actionType: 'block' | 'note';
  loading?: boolean;
  allowOptionalNote?: boolean;
}

export const AdminActionModal: React.FC<AdminActionModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  actionType,
  loading = false,
  allowOptionalNote = false,
}) => {
  const [inputValue, setInputValue] = useState('');

  const handleConfirm = () => {
    if (actionType === 'note' || (actionType === 'block' && allowOptionalNote)) {
      onConfirm(inputValue || undefined);
    } else {
      onConfirm();
    }
    setInputValue('');
  };

  const handleClose = () => {
    setInputValue('');
    onClose();
  };

  const showInput = actionType === 'note' || (actionType === 'block' && allowOptionalNote);
  const isRequired = actionType === 'note';
  const isConfirmDisabled = showInput && isRequired && !inputValue.trim();

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title={title}>
      <div className="space-y-4">
        <p className="text-gray-600">{message}</p>

        {showInput && (
          <div>
            {actionType === 'note' ? (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Admin Note
                </label>
                <textarea
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  placeholder="Enter admin note..."
                  rows={4}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-slate-500 focus:border-transparent resize-none"
                />
              </div>
            ) : actionType === 'block' && allowOptionalNote ? (
              <Input
                label="Block Note (Optional)"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                placeholder="Add a note about this action..."
                required={false}
              />
            ) : null}
          </div>
        )}

        <div className="flex justify-end gap-3 pt-4">
          <Button variant="outline" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleConfirm}
            disabled={loading || isConfirmDisabled}
          >
            {loading ? 'Processing...' : 'Confirm'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
